import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const ref = useRef(null);

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch((e) => console.error("Failed to load notifications", e));
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const unread = items.filter((i) => !i.read).length;

  const openItem = async (i) => {
    try { await api.patch(`/notifications/${i.id}/read`); } catch (e) { console.error("Failed to mark notification read", e); }
    setOpen(false);
    load();
    if (i.link) navigate(i.link);
  };
  const markAll = async () => { try { await api.post("/notifications/read-all"); } catch (e) { console.error("Failed to mark all read", e); } load(); };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notif-bell" onClick={() => setOpen((o) => !o)}
        className="relative p-2 text-slate-300 hover:text-[#00F0FF] transition-colors">
        <Bell className="w-5 h-5" />
        {unread > 0 && (
          <span data-testid="notif-badge"
            className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 text-[10px] font-mono-rs bg-[#D902EE] text-white rounded-full flex items-center justify-center">
            {unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notif-dropdown"
          className="absolute left-0 md:left-auto md:right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-[#0F1219] border border-[#D902EE]/40 z-50 rs-glow-magenta">
          <div className="flex items-center justify-between px-3 py-2 border-b border-slate-800 sticky top-0 bg-[#0F1219]">
            <span className="text-xs font-mono-rs uppercase tracking-wider text-[#00F0FF]">Notifications</span>
            <button data-testid="notif-mark-all" onClick={markAll}
              className="text-[10px] text-slate-400 hover:text-white uppercase tracking-wider">Mark all read</button>
          </div>
          {items.length === 0 && <div className="px-3 py-6 text-center text-sm text-slate-500">No notifications</div>}
          {items.map((i) => (
            <button key={i.id} data-testid={`notif-item-${i.id}`} onClick={() => openItem(i)}
              className={`w-full text-left px-3 py-2 border-b border-slate-800/60 hover:bg-[#171A21] transition-colors ${!i.read ? "bg-[#8A2BE2]/10" : ""}`}>
              <div className="flex gap-2">
                {!i.read && <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#D902EE] shrink-0" />}
                <span className="text-xs text-slate-200 leading-snug">{i.text}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
